
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("kJ9vR", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $ec644d026fe902e0$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Russian
var $ec644d026fe902e0$export$2e2bcd8739ae039 = {
    'navigation.global-shortcuts.all-sites': "\u0412\u0441\u0435 \u0441\u0430\u0439\u0442\u044B",
    'navigation.global-shortcuts.menu-expand-item.close-button-aria-label': "\u0417\u0430\u043A\u0440\u044B\u0442\u044C",
    'navigation.global-shortcuts.menu-link-item.disabled-item-aria-label': "(\u0441\u0435\u0439\u0447\u0430\u0441 \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u043E)",
    'navigation.global-shortcuts.sites': "\u0421\u0430\u0439\u0442\u044B {productName}"
};

});


//# sourceMappingURL=ru.88785d48.js.map
